export default "__VITE_ASSET__333a1d96__"